import { MessageLibraryRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/message-library')({
  component: MessageLibraryRoute,
});
